<app-access-item>
  <app-access-item-icon>
    <app-gallery-settings-icon src="/assets/icons/alignment-center.svg"> </app-gallery-settings-icon>
  </app-access-item-icon>
  <app-access-item-header>
    <div>Text Position</div>
  </app-access-item-header>

  <app-access-item-cta>
    <app-context-menu [options]="{ width: '190px' }">
      <button
        appButton
        name="text-position"
        location="gallery-cover"
        color="simple"
        height="1"
        shape="round"
        [hasIcon]="true"
        weight="bold"
        contextButton
      >
        <span>{{ theme().cover.content_position | coverTextPositionLabel }}</span>
        <app-svg src="/assets/icons/24/chevron-down.svg" size="-1"></app-svg>
      </button>
      <div contextContent class="text-position-container">
        @for (position of textPositions; track position) {
          <div
            [class.active]="
              theme().cover.content_position[0] === position[0] && theme().cover.content_position[1] === position[1]
            "
            (click)="updateTextPosition(position)"
          >
            @if (position[0] !== 0.5 || position[1] !== 0.5) {
              <app-svg src="/assets/icons/arrow-up.svg"></app-svg>
            }
            @if (position[0] === 0.5 && position[1] === 0.5) {
              <app-svg src="/assets/icons/annotate-circle.svg"></app-svg>
            }
          </div>
        }
      </div>
    </app-context-menu>
  </app-access-item-cta>
</app-access-item>
